import { render, staticRenderFns } from "./AggregateLearningLeaderboardRow.vue?vue&type=template&id=449bd810&scoped=true"
import script from "./AggregateLearningLeaderboardRow.vue?vue&type=script&lang=js"
export * from "./AggregateLearningLeaderboardRow.vue?vue&type=script&lang=js"
import style0 from "./AggregateLearningLeaderboardRow.vue?vue&type=style&index=0&id=449bd810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449bd810",
  null
  
)

export default component.exports